import { Controller } from "@hotwired/stimulus"

// Handles per-row interactions for shareholder form rows
// Toggles EIN/SSN field enabled state based on foreign entity checkbox
export default class extends Controller {
  static targets = ["foreignEntityCheckbox", "einSsnVisible", "einSsnHidden"]

  toggleEinSsn(event) {
    if (!this.hasEinSsnVisibleTarget) return

    const isChecked = this.foreignEntityCheckboxTarget.checked

    if (isChecked) {
      // Foreign entity - disable and optionally clear EIN/SSN
      const currentValue = this.einSsnHiddenTarget?.value || this.einSsnVisibleTarget.value
      if (currentValue && currentValue.trim() !== "") {
        if (!window.confirm("This will clear the EIN/SSN value. Continue?")) {
          // User cancelled - uncheck the box and stop event to prevent autoSave
          this.foreignEntityCheckboxTarget.checked = false
          event.stopImmediatePropagation()
          return
        }
        // Clear both visible and hidden inputs
        this.einSsnVisibleTarget.value = ""
        if (this.hasEinSsnHiddenTarget) {
          this.einSsnHiddenTarget.value = ""
        }
      }
      this.einSsnVisibleTarget.disabled = true
    } else {
      // Not foreign entity - enable EIN/SSN
      this.einSsnVisibleTarget.disabled = false
    }
  }
}
